
import { useState, useEffect } from 'react';
import { getStoredAuthData } from './authUtils';
import { getDefaultNotificationPreferences } from '@/services/notificationService';
import { User } from './types';
import { UserRoles } from '@/contexts/auth/enums';

export const useAuthState = () => {
  const [user, setUser] = useState<User | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  // Initialize auth state from local storage
  useEffect(() => {
    const { token: storedToken, user: storedUser } = getStoredAuthData();
    console.log('Retrieved stored auth data:', { token: !!storedToken, user: storedUser });

    if (storedToken && storedUser) {
      // Ensure user has all required fields
      const normalizedUser: User = {
        '@id': storedUser['@id'] || 'temp-id',
        email: storedUser.email || '',
        roles: Array.isArray(storedUser.roles) ? storedUser.roles : [UserRoles.USER],
        userProfile: {
          name: storedUser.userProfile?.name || {
            firstName: '',
            lastName: ''
          },
          '@id': storedUser.userProfile?.['@id'],
          companyInfo: storedUser.userProfile?.companyInfo || undefined,
          notificationPreferences: storedUser.userProfile.notificationPreferences || getDefaultNotificationPreferences(),
        },
        emailVerified: storedUser.emailVerified,
      };

      console.log('Normalized user object:', normalizedUser);
      setToken(storedToken);
      setUser(normalizedUser);
    }

    setIsLoading(false);
  }, []);

  return {
    user,
    setUser,
    token,
    setToken,
    isLoading,
    isAuthenticated: !!token && !!user
  };
};
